import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { analytics } from "@/utils/analytics";

// Fire PostHog before React mounts so the very first pageview is captured.
// Guarded internally — a missing env key results in a no-op, never a crash.
analytics.init();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
